import React, { useCallback } from 'react'
import { ThemeProvider } from '@material-ui/core'
import { getSectionTheme } from '@v4/utils/theme'

const withPrimaryColor = WrappedComponent => ({ primaryColor, ...restProps }) => {
	const theme = useCallback(
		parentTheme =>
			getSectionTheme(parentTheme, {
				palette: {
					primary: primaryColor,
				},
			}),
		[primaryColor],
	)

	if (primaryColor && primaryColor !== 'inherit') {
		return (
			<ThemeProvider theme={theme}>
				<WrappedComponent {...restProps} />
			</ThemeProvider>
		)
	}

	return <WrappedComponent {...restProps} />
}

export default withPrimaryColor
